import { initModal } from './modal'
import { saveStateWithAjax, checkKey, getCodeAndCheckBoxMap } from './screen-package-selection-global'
import { getPackageImages_etron, checkLocks_etron, updateBackgroundImage } from './screen-package-selection-etron'
import { getPackageImages_etron_2025, checkLocks_etron_2025 } from './screen-package-selection-etron-2025'
import { getPackageImages_a6limousine, checkLocks_a6limousine } from './screen-package-selection-a6limousine'
import { getPackageImages_q7, checkLocks_q7 } from './screen-package-selection-q7'
import { getPackageImages_q8, checkLocks_q8 } from './screen-package-selection-q8'
import { getPackageImages_rsq8, checkLocks_rsq8 } from './screen-package-selection-rsq8'
import { getPackageImages_a8, checkLocks_a8 } from './screen-package-selection-a8'
import { getPackageImages_a6_c9, checkLocks_a6_c9 } from './screen-package-selection-a6_c9'
import { getPackageImages_a6_c9_s_line, checkLocks_a6_c9_s_line } from './screen-package-selection-a6_c9_s_line'
import { getPackageImages_q7q9, checkLocks_q7q9 } from './screen-package-selection-q7q9'

const initPackageSelectionModal = () => {
	var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
	var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
	var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
	var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

	addListeners(modalsCheckboxesMap, frontCheckboxesMap)
	initModal(cancelModal,canSubmitModal);

	const $carmodel = document.getElementsByName("carmodel")[0].value;
		
	if (($carmodel > 21) && ($carmodel < 28)) {
		if (frontCheckboxesMap['N1V'].checked){
			frontCheckboxesMap['YXK'].disabled = true
		} 		
		document.getElementById("submit_button").disabled = true;
	}

}

function isCheckboxCheckedByAuiCode(auiCode) {
    const label = document.querySelector(`label[data-auicode="${auiCode}"]`);
    if (label) {
        const checkbox = label.querySelector('input[type="checkbox"]');
        return checkbox ? checkbox.checked : false;
    }
    return false;
}

/*
function updateBackgroundImage() {
	const isYVN_Checked = isCheckboxCheckedByAuiCode('YVN');
	const isYVU_Checked = isCheckboxCheckedByAuiCode('YVU_etron');
	const isYVJ = isCheckboxCheckedByAuiCode('YVJ');
	//Basisbild austauschen
    if (isYVN_Checked) {
				document.getElementById("front_background_image").src="img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_basislayer-yve.png";
	} else if (isYVU_Checked) {
		document.getElementById("front_background_image").src="img/01_interieur/paketauswahl/au513_s_e-tron_gt_paketauswahl_basislayer.png";
	} else {
		document.getElementById("front_background_image").src="img/01_interieur/paketauswahl/au513_s_e-tron_gt_paketauswahl_basislayer.png";
	}
}
*/
   

function addListeners(checkboxes, frontCheckboxesMap) {
	const $carmodel = document.getElementsByName("carmodel")[0].value;
		
	if (($carmodel == 2) || ($carmodel == 200) || ($carmodel == 201)) {
		checkboxes['YVU_etron'].addEventListener('change', function () {
			checkboxes['YVN'].disabled = this.checked
			changeElementsCheckWithCode('YVU_etron', frontCheckboxesMap, this.checked)
		})
		
		checkboxes['YVN'].addEventListener('change', function () {
			checkboxes['YVU_etron'].disabled = this.checked
			changeElementsCheckWithCode('YVN', frontCheckboxesMap, this.checked)
			updateBackgroundImage();
			//document.getElementById("YVN-YVJ-img").style.display = "block";
		})
		
		const isRSModel = checkKey(checkboxes, 'YTU')
		if (isRSModel) {
			checkboxes['YTU'].addEventListener('change', function () {
				checkboxes['YSR'].disabled = this.checked
				changeElementsCheckWithCode('YTU', frontCheckboxesMap, this.checked)
			})

			checkboxes['YSR'].addEventListener('change', function () {
				checkboxes['YTU'].disabled = this.checked
				changeElementsCheckWithCode('YSR', frontCheckboxesMap, this.checked)
			})
		}
	}
	if (($carmodel == 1)) {
		checkboxes['YVU_etron'].addEventListener('change', function () {
			checkboxes['YVQ_etronGT'].disabled = this.checked
			changeElementsCheckWithCode('YVU_etron', frontCheckboxesMap, this.checked)
		})
		
		checkboxes['YVQ_etronGT'].addEventListener('change', function () {
			checkboxes['YVU_etron'].disabled = this.checked
			changeElementsCheckWithCode('YVQ_etronGT', frontCheckboxesMap, this.checked)
			updateBackgroundImage();
		})
	}
		
	if ($carmodel == 201) {
		
		
		/*
		checkboxes['YVU_etron'].addEventListener('change', function () {
			//checkboxes['YVN'].disabled = this.checked
			changeElementsCheckWithCode('YVU_etron', frontCheckboxesMap, this.checked)
		})
			
		
		checkboxes['YVN'].addEventListener('change', function () {
			checkboxes['YVU_etron'].disabled = this.checked
			changeElementsCheckWithCode('YVN', frontCheckboxesMap, this.checked)
		})
			*/
		
		const isRSModel = checkKey(checkboxes, 'YTU')
		if (isRSModel) {
			checkboxes['YTU'].addEventListener('change', function () {
				checkboxes['YSR'].disabled = this.checked
				changeElementsCheckWithCode('YTU', frontCheckboxesMap, this.checked)
			})

			checkboxes['YSR'].addEventListener('change', function () {
				checkboxes['YTU'].disabled = this.checked
				changeElementsCheckWithCode('YSR', frontCheckboxesMap, this.checked)
			})
		}
	}

	if (($carmodel == 24) || ($carmodel == 25) || ($carmodel == 27)) {

		let check_language_modal = document.querySelector('html.aui-js');
		let language_value_modal = check_language_modal.getAttribute("lang");

		checkboxes['YXK_popup'].addEventListener('change', function () {
			if (language_value_modal == 'cn'){
				changeElementsCheckWithCodePillow('YXK', frontCheckboxesMap, this.checked)
			}	
			changeElementsCheckWithCodePillow('N1V', frontCheckboxesMap, this.checked)
			
		})
		jQuery('#ykk_popup_yes .aui-checkbox__input').click(function() {
			
			if (this.checked) {
				$("#ykk_popup_no .aui-checkbox__input").attr("disabled", true);
				document.getElementById("submit_button").disabled = false;
				if (language_value_modal == 'cn'){
					$("#nv1_modal_message").show();	
				}		
			  } else {
				$("#ykk_popup_no .aui-checkbox__input").removeAttr("disabled");
				document.getElementById("submit_button").disabled = true;
				if (language_value_modal == 'cn'){
					$("#nv1_modal_message").hide();	
				}			
			  }
		  });
		  jQuery('#ykk_popup_no .aui-checkbox__input').click(function() {
			  if (this.checked) {
				  $("#ykk_popup_yes .aui-checkbox__input").attr("disabled", true);
				  document.getElementById("submit_button").disabled = false;
					if (language_value_modal == 'cn'){
						$("#nv1_modal_message").hide();
					}	
				} else {
				  $("#ykk_popup_yes .aui-checkbox__input").removeAttr("disabled");
				  document.getElementById("submit_button").disabled = true;
				  if (language_value_modal == 'cn'){
					$("#nv1_modal_message").hide();
					}
				}
			});

			jQuery('label[data-auicode="N1V"]').hide();
	}
	
	if (($carmodel == 11) || ($carmodel == 12) || ($carmodel == 13) || ($carmodel == 14)) {

		let check_language_modal = document.querySelector('html.aui-js');
		let language_value_modal = check_language_modal.getAttribute("lang");

		checkboxes['3NT_popup'].addEventListener('change', function () {
			changeElementsCheckWithCodePillow('3NT', frontCheckboxesMap, this.checked)
			
		})
		jQuery('#three_nt_popup_yes .aui-checkbox__input').click(function() {
			
			if (this.checked) {
				$("#three_nt_popup_no .aui-checkbox__input").attr("disabled", true);
				document.getElementById("submit_button").disabled = false;	
			  } else {
				$("#three_nt_popup_no .aui-checkbox__input").removeAttr("disabled");
				document.getElementById("submit_button").disabled = true;		
			  }
		  });
		  jQuery('#three_nt_popup_no .aui-checkbox__input').click(function() {
			  if (this.checked) {
				  $("#three_nt_popup_yes .aui-checkbox__input").attr("disabled", true);
				  document.getElementById("submit_button").disabled = false;
				} else {
				  $("#three_nt_popup_yes .aui-checkbox__input").removeAttr("disabled");
				  document.getElementById("submit_button").disabled = true;
				}
			});

			jQuery('label[data-auicode="3NT"]').hide();
	}
	
	if (($carmodel == 60) || ($carmodel == 61) || ($carmodel == 62) || ($carmodel == 63) || ($carmodel == 64) || ($carmodel == 65)) {
		checkboxes['Q8H_7HH_A6_C9_popup'].addEventListener('change', function () {
			jQuery("#Q8H_7HH_A6_C9").addClass("is-checked");
			jQuery("#7HF_A6_C9").removeClass("is-checked");
			frontCheckboxesMap['Q8H_A6_C9'].parentElement.classList.add('is-checked')
			frontCheckboxesMap['7HF_A6_C9'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['Q8H_A6_C9'].checked = true;
    		frontCheckboxesMap['7HF_A6_C9'].checked = false;
			document.getElementById("submit_button").disabled = false;
			saveStateWithAjax('Q8H_A6_C9',  true);
			saveStateWithAjax('7HF_A6_C9',  false);	
			//getPackageImages_a6_c9('Q8H_A6_C9', frontCheckboxesMap)
			getPackageImages_a6_c9_s_line('Q8H_A6_C9', frontCheckboxesMap)
			jQuery("#7HF_A6_C9-img").addClass("hidden");
			jQuery("#Q8H_A6_C9-img").removeClass("hidden");
			jQuery('.aui-checkboxes.sidebar-content label.aui-checkbox[data-auicode="7HF_A6_C9"]').hide();
			jQuery('.aui-checkboxes.sidebar-content label.aui-checkbox[data-auicode="Q8H_A6_C9"]').show();
		})
		checkboxes['7HF_A6_C9_popup'].addEventListener('change', function () {
			jQuery("#Q8H_7HH_A6_C9").removeClass("is-checked");
			jQuery("#7HF_A6_C9").addClass("is-checked");
			frontCheckboxesMap['Q8H_A6_C9'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['7HF_A6_C9'].parentElement.classList.add('is-checked')
			frontCheckboxesMap['Q8H_A6_C9'].checked = false;
    		frontCheckboxesMap['7HF_A6_C9'].checked = true;
			document.getElementById("submit_button").disabled = false;
			saveStateWithAjax('Q8H_A6_C9',  false);
			saveStateWithAjax('7HF_A6_C9',  true);	
			//getPackageImages_a6_c9('7HF_A6_C9', frontCheckboxesMap)
			getPackageImages_a6_c9_s_line('7HF_A6_C9', frontCheckboxesMap)
			jQuery("#Q8H_A6_C9-img").addClass("hidden");
			jQuery("#7HF_A6_C9-img").removeClass("hidden");
			jQuery('.aui-checkboxes.sidebar-content label.aui-checkbox[data-auicode="Q8H_A6_C9"]').hide();
			jQuery('.aui-checkboxes.sidebar-content label.aui-checkbox[data-auicode="7HF_A6_C9"]').show();
		})

	}		
}

//THIS HELPS US TO CONNECT FRONTCHECKBOXES WITH THE MODALCHECKBOXES
function changeElementsCheckWithCode(elementCode, frontCheckboxesMap, checkedValue) {
	if(checkedValue){
		frontCheckboxesMap[elementCode].checked = true
		frontCheckboxesMap[elementCode].parentElement.classList.add('is-checked')
		//frontCheckboxesMap[elementCode].disabled = true
		frontCheckboxesMap[elementCode].click();
	}else{
		frontCheckboxesMap[elementCode].checked = false
		frontCheckboxesMap[elementCode].parentElement.classList.remove('is-checked')
		//frontCheckboxesMap[elementCode].disabled = false
		frontCheckboxesMap[elementCode].click();
	}

	if((elementCode == "YRB") || (elementCode == "YVU_etron")){
		getPackageImages_etron("YVU_etron", frontCheckboxesMap)
	} else if (elementCode == "YVN") {
		getPackageImages_etron("YVN", frontCheckboxesMap)
	} else if (elementCode == "YTU") {
		getPackageImages_etron('YTU', frontCheckboxesMap)
	} else if (elementCode == "YSR") {
		getPackageImages_etron('YSR', frontCheckboxesMap)
	}
	
	saveStateWithAjax(elementCode, checkedValue);
}

function changeElementsCheckWithCodePillow(elementCode, frontCheckboxesMap, checkedValue) {
	if(checkedValue){
		frontCheckboxesMap[elementCode].checked = false
		frontCheckboxesMap[elementCode].parentElement.classList.remove('is-checked')
		frontCheckboxesMap[elementCode].click();
	}else{
		frontCheckboxesMap[elementCode].checked = true
		frontCheckboxesMap[elementCode].parentElement.classList.add('is-checked')
		frontCheckboxesMap[elementCode].click();
	}
	saveStateWithAjax(elementCode, checkedValue);
}

//called when modal is cancelled
function cancelModal() {
	const carModel = document.querySelector("input[name=carmodel]").value;
	const modal = document.querySelectorAll('.modal')[0]

	if (((carModel > 2) && (carModel < 22)) || ((carModel > 27) && (carModel < 60)) || (carModel == 70) || (carModel == 71)) {
		modal.classList.add("hidden")
	} else if ((carModel > 21) && (carModel < 28)) {
		// A8 modal 
		var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

		if (frontCheckboxesMap['YZ1_A8'].checked){
			frontCheckboxesMap['YZ1_A8'].disabled = false
			frontCheckboxesMap['YZ1_A8'].click()
		} 
		if (frontCheckboxesMap['YZ4_A8'].checked){
			frontCheckboxesMap['YZ4_A8'].disabled = false
			frontCheckboxesMap['YZ4_A8'].click()
		} 
	} else if ((carModel > 59) && (carModel < 68)) {
		// A6 C9 modal 
		var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

		if (frontCheckboxesMap['Q8H_A6_C9'].checked){
			frontCheckboxesMap['Q8H_A6_C9'].disabled = false
			frontCheckboxesMap['Q8H_A6_C9'].click()
		} 
		if (frontCheckboxesMap['7HF_A6_C9'].checked){
			frontCheckboxesMap['7HF_A6_C9'].disabled = false
			frontCheckboxesMap['7HF_A6_C9'].click()
		} 
		if ((carModel == 61) || (carModel == 63) || (carModel == 64) || (carModel == 65)) {
			if (frontCheckboxesMap['YFA_A6_C9'].checked){
				frontCheckboxesMap['YFA_A6_C9'].disabled = false
				frontCheckboxesMap['YFA_A6_C9'].click()
			} 
		}
	} else if ((carModel == 35) || (carModel == 36) || (carModel == 38) || (carModel == 39)) {
		// Q6 etron 
		var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

		if (frontCheckboxesMap['Q8H_Q6etron'].checked){
			frontCheckboxesMap['Q8H_Q6etron'].disabled = false
			frontCheckboxesMap['Q8H_Q6etron'].click()
		} 
		if (frontCheckboxesMap['7HF_Q6etron'].checked){
			frontCheckboxesMap['7HF_Q6etron'].disabled = false
			frontCheckboxesMap['7HF_Q6etron'].click()
		} 

		if (frontCheckboxesMap['YFA_Q6etron'].checked){
			frontCheckboxesMap['YFA_Q6etron'].disabled = false
			frontCheckboxesMap['YFA_Q6etron'].click()
		} 
	
	} else if ((carModel == 51) || (carModel == 53) || (carModel == 54) || (carModel == 55)) {
		// A6 etron 
		var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

		if (frontCheckboxesMap['Q8H_A6etron'].checked){
			frontCheckboxesMap['Q8H_A6etron'].disabled = false
			frontCheckboxesMap['Q8H_A6etron'].click()
		} 
		if (frontCheckboxesMap['7HF_A6etron'].checked){
			frontCheckboxesMap['7HF_A6etron'].disabled = false
			frontCheckboxesMap['7HF_A6etron'].click()
		} 

		if (frontCheckboxesMap['YFA_A6etron'].checked){
			frontCheckboxesMap['YFA_A6etron'].disabled = false
			frontCheckboxesMap['YFA_A6etron'].click()
		} 

	} else if ((carModel == 41) || (carModel == 43) || (carModel == 44) || (carModel == 45)) {
		// A5
		var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

		if (frontCheckboxesMap['Q8H_A5'].checked){
			frontCheckboxesMap['Q8H_A5'].disabled = false
			frontCheckboxesMap['Q8H_A5'].click()
		} 
		if (frontCheckboxesMap['7HF_A5'].checked){
			frontCheckboxesMap['7HF_A5'].disabled = false
			frontCheckboxesMap['7HF_A5'].click()
		} 

		if (frontCheckboxesMap['YFA_A5'].checked){
			frontCheckboxesMap['YFA_A5'].disabled = false
			frontCheckboxesMap['YFA_A5'].click()
		} 

	} else {
		var modalCheckboxes = document.querySelectorAll('.modal-checkboxes .aui-checkbox__input')
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var modalsCheckboxesMap = getCodeAndCheckBoxMap(modalCheckboxes)
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)

		frontCheckboxesMap['YVJ'].disabled = false
		frontCheckboxesMap['YVJ'].click();
		
		if (frontCheckboxesMap['YVU_etron'].checked){
			frontCheckboxesMap['YVU_etron'].disabled = false
			frontCheckboxesMap['YVU_etron'].click()
		} 
		if (carModel == 1){
			if (frontCheckboxesMap['YVQ_etronGT'].checked) {
				frontCheckboxesMap['YVQ_etronGT'].disabled = false
				frontCheckboxesMap['YVQ_etronGT'].click()
			} 
		} else {
			if (frontCheckboxesMap['YVN'].checked) {
				frontCheckboxesMap['YVN'].disabled = false
				frontCheckboxesMap['YVN'].click()
			} 
		}
		
		const isRSModel = checkKey(frontCheckboxesMap, 'YTU')
		if (isRSModel) {
			if (frontCheckboxesMap['YSR'].checked) {
				frontCheckboxesMap['YSR'].disabled = false
				frontCheckboxesMap['YSR'].click()
			}
			if (frontCheckboxesMap['YTU'].checked) {
				frontCheckboxesMap['YTU'].disabled = false
				frontCheckboxesMap['YTU'].click()
			}
		}






		if (frontCheckboxesMap['YFA_etronGT'].checked){
			
			modal.classList.add("hidden")		   

			frontCheckboxesMap['YFA_etronGT'].disabled = false
			frontCheckboxesMap['YFA_etronGT'].click()
			frontCheckboxesMap['YFB_etronGT'].disabled = false
			


			if (frontCheckboxesMap['YVJ'].checked) {
				frontCheckboxesMap['YVJ'].click()
				frontCheckboxesMap['YVJ'].disabled = false
				frontCheckboxesMap['YVJ'].parentElement.classList.remove('is-checked')
			}

			frontCheckboxesMap['YVE'].disabled = false

			frontCheckboxesMap['YS1'].disabled = false
			frontCheckboxesMap['YS1'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['YVU_etron'].disabled = false
			frontCheckboxesMap['YVU_etron'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['YVN'].disabled = false
			frontCheckboxesMap['YVN'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['YSR'].disabled = false
			frontCheckboxesMap['YSR'].parentElement.classList.remove('is-checked')
		} 

		if (frontCheckboxesMap['YFB_etronGT'].checked){
			
			modal.classList.add("hidden")		   

			frontCheckboxesMap['YFB_etronGT'].disabled = false
			frontCheckboxesMap['YFB_etronGT'].click()
			frontCheckboxesMap['YFA_etronGT'].disabled = false
			frontCheckboxesMap['YVU_etron'].disabled = false
			frontCheckboxesMap['YVU_etron'].parentElement.classList.remove('is-checked')
		} 

		
		checkLocks_etron(frontCheckboxesMap);




		//change visibility
		if (document.getElementById('YVN-YVJ-img') != null) {
			document.getElementById('YVN-YVJ-img').hidden = true
		}
		if (document.getElementById('YRB-YVJ-img') != null) {
			document.getElementById('YRB-YVJ-img').hidden = true
		}
	}	
}

//called when modal is accepted
function canSubmitModal() {

	const carModel = document.querySelector("input[name=carmodel]").value;
	const modal = document.querySelectorAll('.modal')[0]

	if ((carModel == 70) || (carModel == 71)) {
		return
	}

	if (carModel > 2) {
		modal.classList.add("hidden")
	} else if (carModel == 1){
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)
		return frontCheckboxesMap['YVU_etron'].checked || frontCheckboxesMap['YVQ_etronGT'].checked
	} else {
		var frontCheckboxes = document.querySelectorAll('.aui-checkboxes .aui-checkbox__input')
		var frontCheckboxesMap = getCodeAndCheckBoxMap(frontCheckboxes)
		const isRSModel = checkKey(frontCheckboxesMap, 'YTU')
		var firstCondition = (frontCheckboxesMap['YVU_etron'].checked || frontCheckboxesMap['YVN'].checked)
		var secondCondition = isRSModel ? (frontCheckboxesMap['YSR'].checked || frontCheckboxesMap['YTU'].checked) : true
		return firstCondition && secondCondition;
	}	
}

export { initPackageSelectionModal }
